import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

const clauseSearchSchema = z.object({
  componentDefinitionId: z.string().optional().catch(undefined),
  reviewId: z.string().optional().catch(undefined),
  reviewComponentId: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/$workspaceId/clause')({
  validateSearch: (raw) => clauseSearchSchema.parse(raw),
})
